module.exports = __webpack_public_path__ + "static/img/pg1.66ab62f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/pg1.png
// module id = 7XZy
// module chunks = 1